/**
 * FilterChips — a row of toggle-style filter buttons (.fchip).
 *
 * Renders a `role="group"` container with one button per option.
 * The active option receives `aria-pressed="true"` and the `.on`
 * modifier class, matching the brandbook's .fchip / .fchip.on styles.
 * Used on Activity, Files, and any screen that needs a filter bar.
 */

export type FilterChipsProps<V extends string> = {
  options: ReadonlyArray<{ value: V; label: string }>;
  value: V;
  onChange: (v: V) => void;
  ariaLabel?: string;
};

export function FilterChips<V extends string>({
  options,
  value,
  onChange,
  ariaLabel,
}: FilterChipsProps<V>) {
  return (
    <div className="filters" role="group" aria-label={ariaLabel ?? "Filters"}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={o.value === value ? "fchip on" : "fchip"}
          aria-pressed={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
